<template>
  <section class="rounded-box border border-base-300 bg-base-100 p-4">
    <h2 class="text-base font-semibold">{{ t('aiChatAgentSetup.voiceSettings.callLimitsTitle', 'Call limits') }}</h2>
    <p class="mt-1 text-xs text-base-content/60">
      {{ t('aiChatAgentSetup.voiceSettings.callLimitsDescription', 'Control call duration and repeated usage from the same caller number.') }}
    </p>
    <div class="mt-4 grid md:grid-cols-3">
      <div class="form-control mb-4 md:mr-4">
        <label class="label">
          <span class="label-text">{{ t('aiChatAgentSetup.voiceSettings.maxCallMinutes', 'Maximum minutes per call') }}</span>
        </label>
        <input v-model.number="maxCallMinutesModel" type="number" min="0.25" max="1440" step="0.25" class="input input-bordered w-full" />
        <p class="mt-1 text-xs text-base-content/60">{{ t('aiChatAgentSetup.voiceSettings.maxCallMinutesHint', 'The call is automatically ended at this limit.') }}</p>
      </div>
      <div class="form-control mb-4 md:mr-4">
        <label class="label">
          <span class="label-text">{{ t('aiChatAgentSetup.voiceSettings.maxCallerMinutes', 'Maximum minutes per caller number') }}</span>
        </label>
        <input v-model.number="maxCallerMinutesModel" type="number" min="0.25" max="1440" step="0.25" class="input input-bordered w-full" />
        <p class="mt-1 text-xs text-base-content/60">{{ t('aiChatAgentSetup.voiceSettings.maxCallerMinutesHint', 'Calls from the same number are rejected after this usage.') }}</p>
      </div>
      <div class="form-control mb-4">
        <label class="label">
          <span class="label-text">{{ t('aiChatAgentSetup.voiceSettings.callerCooldownMinutes', 'Caller usage window in minutes') }}</span>
        </label>
        <input v-model.number="callerCooldownMinutesModel" type="number" min="1" max="43200" step="1" class="input input-bordered w-full" />
        <p class="mt-1 text-xs text-base-content/60">{{ t('aiChatAgentSetup.voiceSettings.callerCooldownMinutesHint', 'Usage becomes available again as calls leave this window.') }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from '@/i18n';

const props = defineProps({
  maxCallMinutes: { type: Number, default: 19 },
  maxCallerMinutes: { type: Number, default: 19 },
  callerCooldownMinutes: { type: Number, default: 60 }
});

const emit = defineEmits([
  'update:maxCallMinutes',
  'update:maxCallerMinutes',
  'update:callerCooldownMinutes'
]);

const { t } = useI18n();

const maxCallMinutesModel = computed({
  get: () => props.maxCallMinutes,
  set: (value) => emit('update:maxCallMinutes', value)
});

const maxCallerMinutesModel = computed({
  get: () => props.maxCallerMinutes,
  set: (value) => emit('update:maxCallerMinutes', value)
});

const callerCooldownMinutesModel = computed({
  get: () => props.callerCooldownMinutes,
  set: (value) => emit('update:callerCooldownMinutes', value)
});
</script>
